import fetchApi from 'services/api/connector';

export const fetchLatestVulns = (ws, confirmed) => fetchApi(`ws/${ws}/vulns?page=0&page_size=5&sort=date&sort_dir=desc${confirmed ? '&confirmed=1' : ''}`);

export const getVulnsCountByStatus = (ws, params = '') => fetchApi(`ws/${ws}/vulns/count?group_by=status${params}`);

export const getVulnsCountBySeverity = (ws, params = '') => fetchApi(`ws/${ws}/vulns/count?group_by=severity${params}`);

export const getTopHostsDashboard = (ws) => fetchApi(`ws/${ws}/hosts?page=1&page_size=10`);

export const getTopHostsBySeverity = (ws) => {
  const qFilter = encodeURIComponent(JSON.stringify({
    filters: [],
    order_by: [
      { field: 'vulnerability_critical_generic_count', direction: 'desc' },
      { field: 'vulnerability_high_generic_count', direction: 'desc' }
    ],
    offset: 0,
    limit: 10
  }));
  return fetchApi(`ws/${ws}/hosts/filter?q=${qFilter}`);
};

export const getVulnsCountByMultiWs = (ws, param) => fetchApi(`ws/${ws}/vulns/count_multi_workspace?group_by=severity&workspaces=${ws}${param}`);

export const getTopServicesByName = (ws) => fetchApi(`ws/${ws}/services/count?group_by=name`);

export const getVulnsTimeline = (ws) => fetchApi(`ws/${ws}/vulns/timeline`);

export const getActivitiesList = (ws, page) => fetchApi(`ws/${ws}/activities?page_size=16&page=${page}`);

export const getCommandHistory = (ws, page) => fetchApi(`ws/${ws}/commands?page_size=16&page=${page}`);

// TODO: Implement when backend adds /api/ws/{ws}/pentest_status
export const fetchPentestStatus = () => Promise.resolve(null);

// TODO: Implement when backend adds /api/ws/{ws}/vulns/timeline
export const fetchFoundVsClosedTimeline = () => Promise.resolve({ timeline: [] });

// TODO: Implement when backend adds /api/ws/{ws}/services?sort=-created_at
export const fetchNewServices = () => Promise.resolve({ services: [] });

// TODO: Implement when backend adds /api/ws/{ws}/hosts?sort=-created_at
export const fetchNewAssets = () => Promise.resolve({ hosts: [] });
